import { Button, Icons, Text } from '@mnd-frontend/ui/publish/components';
import { useTranslation } from 'react-i18next';

const PanelHeader = ({
  header,
  showBackButton,
  onBackClick,
}: {
  header?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}) => {
  const { t } = useTranslation();

  if (showBackButton && onBackClick) {
    return (
      <Button
        type="button"
        configuration="text"
        onClick={onBackClick}
        leadingIcon={<Icons.ChevronLeft />}
      >
        {t('common_back')}
      </Button>
    );
  }
  return (
    <Text as="h3" variant="headlineSmall">
      {header}
    </Text>
  );
};

export default PanelHeader;
